export default __webpack_public_path__ + "static/media/ggplay-card.961932eb.png";